import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import AIResponseGuidelinesPanel from '@/components/organisms/Dialogs/Action/SubAgent/AIResponseGuidelinesPanel';
import { useAIResponseSubAgentConfig } from '@/components/organisms/Dialogs/Action/SubAgent/useAIResponseSubAgentConfig';
import { selectSelectedAction } from '@/redux/dialogs/selectors';
import { clearSelection } from '@/redux/nodes/actions';
import { SubAgentAction } from '@/shared/types/action';

/**
 * Toolkit entry for a selected `sub_agent` (ai_response) action. There is no
 * dedicated right panel — selecting the action opens the guideline editor
 * directly as a wide side drawer (`AIResponseGuidelinesPanel`), mirroring the
 * Authentication guidelines editor. Closing the drawer clears the selection.
 *
 * Guidelines is optional — an empty value is valid (runtime falls back to plain
 * brain-grounded synthesis), so there is no save-blocking validation here.
 */
const ToolkitAIResponse = () => {
  const dispatch = useDispatch();
  const selected = useSelector(selectSelectedAction);
  const action = selected?.type === 'sub_agent' ? (selected as SubAgentAction) : null;
  const actionId = action?.action_id ?? '';

  const { guidelines, onGuidelinesChange } = useAIResponseSubAgentConfig(
    actionId,
    action ?? ({} as SubAgentAction)
  );

  const handleClose = useCallback(() => {
    dispatch(clearSelection());
  }, [dispatch]);

  if (!action) {
    return null;
  }

  return (
    <AIResponseGuidelinesPanel
      key={actionId}
      guidelines={guidelines}
      onChange={onGuidelinesChange}
      onClose={handleClose}
    />
  );
};

export default ToolkitAIResponse;
